import { Navigate } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';
import { useUserInformation } from '@/hooks/use-user-information';

export function RootNavigate() {
  const { isChainRole, isWeddingRole } = useUserInformation();

  const targetRoute = isChainRole
    ? ROUTES_PATH.myOrganization
    : isWeddingRole
      ? ROUTES_PATH.bannerManagement
      : ROUTES_PATH.organizationList;

  return <Navigate to={targetRoute} replace />;
}
